export const CALLBACK_URLS = {
    registeredCallbackUrl: 'http://appurl/notification/account',
    calledCallbackUrl: 'http://appurl/notification/account?subType=account&access_token=hskroxn2o4ishm456',
}



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Structure/Web/PubSubConstants.js